import { useEffect } from 'react';
import { TourConfig, startTourIfNew, startTour } from './TourSystem';
import 'driver.js/dist/driver.css';

const settingsTourConfig: TourConfig = {
    tourId: 'settings',
    steps: [
        {
            popover: {
                title: '⚙️ Welcome to Settings!',
                description: 'Your control center for personalizing your TechUnity experience! Configure your profile, privacy, notifications, integrations, billing, security, and much more. Let\'s customize everything to work perfectly for you!',
            }
        },
        {
            element: '#settings-tabs',
            popover: {
                title: '📑 Settings Categories',
                description: 'Navigate through different settings sections! Each tab organizes related settings: Profile, Account, Privacy, Notifications, Integrations, Billing, Security, and Appearance. Click any tab to access those settings!',
                side: "bottom",
            }
        },
        {
            element: '#settings-profile',
            popover: {
                title: '👤 Profile Settings',
                description: 'Manage your public profile! Update your name, bio, avatar, cover photo, job title, location, social links, and portfolio. This is how others see you across the platform!',
                side: "right",
            }
        },
        {
            element: '#settings-account',
            popover: {
                title: '🔐 Account Settings',
                description: 'Control your account fundamentals! Change your email, update password, manage connected accounts, enable two-factor authentication (2FA), and view login history. Keep your account secure!',
                side: "right",
            }
        },
        {
            element: '#settings-privacy',
            popover: {
                title: '🔒 Privacy Controls',
                description: 'Control who sees what! Manage profile visibility, connection settings, data sharing preferences, search engine indexing, and more. Your privacy, your rules!',
                side: "right",
            }
        },
        {
            element: '#settings-notifications',
            popover: {
                title: '🔔 Notification Preferences',
                description: 'Stay informed your way! Choose which notifications you want via email, push, or in-app. Customize alerts for messages, projects, payments, mentions, and more. Never miss what matters!',
                side: "right",
            }
        },
        {
            element: '#settings-integrations',
            popover: {
                title: '🔗 Third-Party Integrations',
                description: 'Connect your favorite tools! Integrate with Slack, GitHub, Google Drive, Zoom, Stripe, and more. Sync data, automate workflows, and boost productivity by connecting TechUnity with your existing tools!',
                side: "right",
            }
        },
        {
            element: '#settings-billing',
            popover: {
                title: '💳 Billing & Payments',
                description: 'Manage your finances! View current plan, upgrade/downgrade, add payment methods, view invoices, track usage, and manage subscriptions. Full control over your billing!',
                side: "right",
            }
        },
        {
            element: '#settings-appearance',
            popover: {
                title: '🎨 Appearance Customization',
                description: 'Make it yours! Choose between light/dark themes, adjust color schemes, customize the dashboard layout, set font sizes, and personalize the interface to match your preferences!',
                side: "right",
            }
        },
        {
            element: '#settings-save',
            popover: {
                title: '💾 Save Your Changes',
                description: 'Don\'t forget to save! After making changes, click the save button to apply them. Changes are saved per section, so you can customize at your own pace!',
                side: "top",
            }
        },
        {
            popover: {
                title: '🎉 Settings Mastered!',
                description: 'You\'re now in full control of your TechUnity experience! Customize every aspect to work perfectly for you. Remember, you can always come back here to adjust settings as your needs evolve! ⚙️✨',
            }
        }
    ],
};

export const startSettingsTour = () => {
    startTour(settingsTourConfig);
};

const SettingsTour = () => {
    useEffect(() => {
        startTourIfNew(settingsTourConfig);
    }, []);

    return null;
};

export default SettingsTour;
